var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("form", { on: { submit: _setup.onSubmitHandler } }, [
    _c(
      "div",
      { staticClass: "list-items-form" },
      [
        _c("v-switch", {
          attrs: { label: "Is Floor", "hide-details": "auto" },
          model: {
            value: _setup.formState.data.isFloor,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "isFloor", $$v)
            },
            expression: "formState.data.isFloor"
          }
        }),
        _c("v-text-field", {
          attrs: {
            disabled: _setup.formState.data.isFloor,
            outlined: "",
            dense: "",
            "error-messages": _setup.formState.errors.area,
            "hide-details": "auto",
            label: "Area"
          },
          model: {
            value: _setup.formState.data.area,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "area", $$v)
            },
            expression: "formState.data.area"
          }
        }),
        _c("v-text-field", {
          attrs: {
            outlined: "",
            dense: "",
            "error-messages": _setup.formState.errors.task,
            "hide-details": "auto",
            label: "Task"
          },
          model: {
            value: _setup.formState.data.task,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "task", $$v)
            },
            expression: "formState.data.task"
          }
        }),
        _c("v-text-field", {
          attrs: {
            outlined: "",
            dense: "",
            "error-messages": _setup.formState.errors.standard,
            "hide-details": "auto",
            label: "Standard"
          },
          model: {
            value: _setup.formState.data.standard,
            callback: function($$v) {
              _vm.$set(_setup.formState.data, "standard", $$v)
            },
            expression: "formState.data.standard"
          }
        }),
        _setup.props.editId
          ? _c(
              "div",
              { staticClass: "edit-actions" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      type: "submit",
                      color: "warning",
                      dark: "",
                      loading: _setup.formState.isLoading
                    }
                  },
                  [_vm._v("Update")]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { type: "button", color: "error", dark: "" },
                    on: { click: _setup.onCancelHandler }
                  },
                  [_vm._v("Cancel")]
                )
              ],
              1
            )
          : _c(
              "v-btn",
              {
                attrs: {
                  type: "submit",
                  disable: _setup.formState.isLoading,
                  loading: _setup.formState.isLoading,
                  dark: "",
                  color: "primary"
                }
              },
              [_vm._v("Submit")]
            )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }